/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { PureComponent } from 'react';
import { number, shape, func, string, bool } from 'prop-types';
import { Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { fileUploadURL } from 'Redux/modules/files/actions';

import styles from './FileUploadField.less';
import FileInputItem, { TYPE_FILE } from './FileInputItem';

const formatValues = list => list.map(i => i);

class FileUploadField extends PureComponent {
  handleSelectedFile = (oldValue, newValue) => {
    const {
      field: { name, value = [] },
      form: { setFieldValue },
      onFileSelected,
    } = this.props;
    let listValue = [...value];
    if (oldValue) {
      listValue = value.map(item => (item.id === oldValue.id ? newValue : item));
    } else {
      listValue.push(newValue);
    }
    setFieldValue(name, listValue);
    onFileSelected(newValue, listValue);
  };

  handleFileRemove = removedValue => {
    const {
      field: { name, value = [] },
      form: { setFieldValue },
      onFileSelected,
    } = this.props;
    const newValue = value.filter(item => item.id !== removedValue.id);
    setFieldValue(name, newValue);
    onFileSelected(removedValue, newValue);
  };

  fileUpload = formData => {
    const { dispatch, action, token } = this.props;
    return dispatch(action(formData, token));
  };

  render() {
    const {
      field: { value, name },
      label,
      form: { touched, errors },
      maxFile,
      type,
      // eslint-disable-next-line no-shadow
      formatValues,
      isPublic,
      allowFileType,
      multiple,
      disabled,
    } = this.props;

    const formatedValues = formatValues(value || []);

    return (
      <Form.Field error={touched && errors[name]}>
        <span>{label}</span>
        <div className={styles.container}>
          {maxFile > formatedValues.length && (
            <FileInputItem
              onFileSelected={this.handleSelectedFile}
              fileUpload={this.fileUpload}
              fileName={name}
              type={type}
              isPublic={isPublic}
              allowFileType={allowFileType}
              multiple={multiple}
              disabled={disabled}
            />
          )}
          {formatedValues.map(item => (
            <FileInputItem
              key={item.id}
              onFileSelected={this.handleSelectedFile}
              fileUpload={this.fileUpload}
              fileName={name}
              value={item}
              handleFileRemove={this.handleFileRemove}
              type={type}
              isPublic={isPublic}
              allowFileType={allowFileType}
              multiple={multiple}
              disabled={disabled}
            />
          ))}
        </div>
        {touched[name] && errors[name] && <div className={styles.error}>{errors[name]}</div>}
      </Form.Field>
    );
  }
}

const mapStateToProps = state => ({
  token: state.auth.data.token,
});

FileUploadField.propTypes = {
  label: string,
  onFileSelected: func,
  action: func,
  formatValues: func,
  field: shape({}).isRequired,
  form: shape({}).isRequired,
  dispatch: func.isRequired,
  maxFile: number,
  type: number,
  token: string,
  isPublic: bool,
  disabled: bool,
  multiple: bool,
  allowFileType: string,
};

FileUploadField.defaultProps = {
  onFileSelected: () => {},
  label: '',
  maxFile: 1,
  type: TYPE_FILE,
  action: fileUploadURL,
  formatValues,
  token: null,
  isPublic: true,
  multiple: false,
  allowFileType: 'image/*',
  disabled: false,
};

export default connect(mapStateToProps)(FileUploadField);
